import React from "react";
import { Col, Container, FloatingLabel, Form, Row } from "react-bootstrap";
import {
  useCreateUserWithEmailAndPassword,
  useUpdateProfile,
} from "react-firebase-hooks/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import auth from "../../../firebase.init";
import Header from "../../Shared/Header/Header";
import Loading from "../../Shared/Loading/Loading";
import SocialLogin from "../SocialLogin/SocialLogin";

const Register = () => {
  let errorElement;
  const [createUserWithEmailAndPassword, user, loading, error] =
    useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });

  const [updateProfile, updating, updateError] = useUpdateProfile(auth);

  if (error || updateError) {
    errorElement = <p className="text-danger">Error: {error?.message}</p>;
  }

  const navigate = useNavigate();

  const navigateLogin = () => {
    navigate("/login");
  };

  const location = useLocation();
  let from = location.state?.from?.pathname || "/";
  if (user) {
    navigate(from, { replace: true });
    console.log(user);
  }

  if (loading || updating) {
    return <Loading></Loading>;
  }

  const handleRegister = async (event) => {
    event.preventDefault();
    const name = event.target.name.value;
    const email = event.target.email.value;
    const password = event.target.password.value;
    await createUserWithEmailAndPassword(email, password);
    await updateProfile({ displayName: name });
    alert("Updated profile");
    console.log("Update profile");
    navigate("/home");
  };

  return (
    <div>
      <Header></Header>
      <Container>
        <Row className="justify-content-md-center">
          <Col
            xs="10"
            lg="5"
            className="mt-3 mx-auto shadow-lg rounded-top px-5 pt-4"
            style={{ color: "#000fff", fontWeight: "400", fontSize: "1.2rem" }}
          >
            <h2 className="text-center my-3" style={{ color: "#CCD6F6" }}>
              Please Register
            </h2>
            <Form onSubmit={handleRegister} className="mb-3">
              <Form.Group className="mb-3" controlId="formBasicText">
                <FloatingLabel label="Your Name">
                  <Form.Control
                    style={{
                      backgroundColor: "transparent",
                      color: "#CCD6F6",
                    }}
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <FloatingLabel label="Email address">
                  <Form.Control
                    style={{
                      backgroundColor: "transparent",
                      color: "#CCD6F6",
                    }}
                    type="email"
                    name="email"
                    placeholder="Email address"
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <FloatingLabel label="Password">
                  <Form.Control
                    style={{
                      backgroundColor: "transparent",
                      color: "#CCD6F6",
                    }}
                    type="password"
                    name="password"
                    placeholder="Password"
                    required
                  />
                </FloatingLabel>
              </Form.Group>
              <button type="submit" className="w-100 btn-All mt-3">
                Register
              </button>
            </Form>
            {errorElement}
            <p
              style={{
                backgroundColor: "transparent",
                color: "#CCD6F6",
              }}
            >
              Already have an account?
              <Link
                to="/login"
                className="text-primary pe-auto text-decoration-none ms-1 text-primary"
                onClick={navigateLogin}
              >
                Please Login
              </Link>
            </p>
          </Col>
        </Row>
        <SocialLogin></SocialLogin>
      </Container>
    </div>
  );
};

export default Register;
